var mentions_default = {
  "mention": "NP2YV",
  "mentionViewer": "_0OU9c",
  "cursorDefault": "-Biwl",
  "cursorPointer": "qNohF"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
